import {
    FETCH_COMPLETED,
    ERROR ,
    DELETE_COMPLETED,
    PUSH_COMPLETED,
    SET_CURRENT_TYPE,
    SET_HISTORY,
    SET_CURRENT_ITEM,
    UPDATE_COMPLETED,
 //   SET_SHOW_EDIT_RECEIVER,
    SET_BILL_GET_ALL_PARAMS,
    EXPORT_COMPLETED,
    GET_BILL_COMPLETED,
    CLEAR
} from "./BillStates"

export default (state, action) => {
    const newState={
        ...state,
    }
    try{
      switch (action.type) {
          case DELETE_COMPLETED:
          case UPDATE_COMPLETED:
          case PUSH_COMPLETED:
            newState.completed = 'COMPLETED'
            return newState
        case FETCH_COMPLETED:
          if(action.payload
             &&action.payload.data.bills
                 ){
                newState.bills = action.payload.data.bills
                newState.itemsInPage = action.payload.data.bills.length
                newState.pageFrom = parseInt(action.payload.data.pageFrom)
                newState.pageTo = parseInt(action.payload.data.pageTo)
                newState.totalItems = parseInt(action.payload.data.quantityItems)
                newState.totalPages = Math.ceil(newState.totalItems/action.options.MaxPerPage)
          }else throw {message:'bills not present in response'}
          return newState
       return newState
           case SET_CURRENT_TYPE:
           if(action.payload.currentType)newState.currentType = action.payload.currentType
           return newState
        case SET_CURRENT_ITEM:
          //  //console.table(newState)
           if(action.payload.currentItemId){
                newState.currentItemId = action.payload.currentItemId
                newState.currentItem = newState.receivers.receivers.filter(item=>item.id===action.payload.currentItemId)[0]
           }
           return newState
       case SET_HISTORY:
           if(action.payload.history)newState.history = action.payload.history
           return newState
      /*  case SET_SHOW_EDIT_RECEIVER:
              if(action.payload.showEditReceiver)newState.showEditReceiver = action.payload.showEditReceiver
              return newState*/
        case SET_BILL_GET_ALL_PARAMS:
            return {
               ...newState,
               ...action.payload
           }
       case EXPORT_COMPLETED:
            //console.log('EXPORT_COMPLETED')
             newState.exportCompleted="SI"
           return newState
       case GET_BILL_COMPLETED:
            return {
               ...newState,
               billData: action.payload
           }
        case ERROR:
       //   //console.log('ERROR Bill Reducer', action)
          if(action.payload.response&&action.payload.response.data.message){
            newState.error = action.payload.response.data.message
          }else
            if(action.payload.response&&action.payload.response.data){
              newState.error = action.payload.response.data
          }else{
            newState.error = action.payload
          }
          return newState
        case CLEAR:
          delete newState.error
          delete newState.exportCompleted
          newState.receivers=[]
          delete newState.billData
          return newState
        default:
          return newState
      }
    }catch(error){
        newState.error = error
        newState.error.action_type= action.type
        newState.error.payload= action.payload
        //console.error(newState.error)
        return newState
    }
}
